import { API } from './../constants'
import authService from './auth.js'

let anotados = null
let datos = null
let resultados = null
let examinadores = null
let examen = null

const examenService = {
  /**
   * Retorna un array con todos los profesores
   *
   * @return {Promise<{}>}
   */
  async traerAnotadosMesaDeExamenPorServicioId (id) {
    const fetchResponse = await fetch(`${API}/anotados-mesa-examen/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    anotados = respuesta.data
    return [...anotados]
  },
  async traerDatosAnotadosExamen (id) {
    const fetchResponse = await fetch(`${API}/datos-inscripcion-examen/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    datos = respuesta.data
    return { ...datos }
  },
  async traerDatosExamenCargadoParaEditar (id) {
    const fetchResponse = await fetch(`${API}/datos-examen-cargado/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    datos = respuesta.data
    return { ...datos }
  },
  async traerResultadosTodos () {
    const fetchResponse = await fetch(`${API}/resultados`)
    const respuesta = await fetchResponse.json()
    resultados = respuesta.data
    return [...resultados]
  },
  async traerProfesoresExaminadores () {
    const fetchResponse = await fetch(`${API}/profesores-examinadores`)
    const respuesta = await fetchResponse.json()
    examinadores = respuesta.data
    return [...examinadores]
  },
  async checkCargaDeExamen (id) {
    const fetchResponse = await fetch(`${API}/check-carga-examen/${id}`)
    const respuesta = await fetchResponse.json()
    datos = respuesta
    return { ...datos }
  },
  async traerDatosExamenCargado (id) {
    const fetchResponse = await fetch(`${API}/examen-cargado/${id}`)
    const respuesta = await fetchResponse.json()
    examen = respuesta.data
    return [...examen]
  },
  cargarExamen (data) {
    return fetch(`${API}/cargar-resultado-examen`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  },
  uploadCartaRecomendacion (data, id) {
    return fetch(`${API}/upload-carta-recomendacion/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  },
  editarExamen (data, id) {
    return fetch(`${API}/editar-examen/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  }
}

export default examenService
